import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getDeliveryChallanEditData,
  updateConfig,
} from "../../../../store/slices/Delivery/deliverySlice";

import { updateConfig as globalUpdateConfig } from "../../../../store/slices/Global";
import {
  approveCertificate,
  // getDeliveryCertificate,
  getPrintChellan,
  getPrintSlip,
  passAll,
  uploadDeliveryChallan,
  downloadDeliveryExcel,
} from "../api";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import moment from "moment";
import { useGetCertificateListDataQuery } from "../../../../store/queries/Delivery";
import { useFormik } from "formik";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import { useState } from "react";

const useDeliveryCertificate = ({ slipRef, chellanRef }) => {
  const deliveryState = useSelector((state) => state.delivery);
  const [loading, setLoading] = useState(false);
  const [loadingChellan, setLoadingChellan] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const { passAllModal, globalRemarkModal } = useSelector(
    (state) => state.global,
  );
  const slug = sessionStorage?.getItem("slug");
  const {
    data: certificateList,
    isLoading,
    isFetching,
    refetch,
  } = useGetCertificateListDataQuery({
    page_size: deliveryState.currentTablePageSize,
    page: deliveryState.currentTablePage,
    sort_by: deliveryState.sortBy,
    sort_order: deliveryState.sortOrder,
    search: deliveryState.search,
    process_slug: slug,
    receipt_id: deliveryState.selectedCardId,
  });

  const formik = useFormik({
    initialValues: {
      remark: "",
    },
  });

  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];
  const dispatch = useDispatch();

  const disableMultiSelect = useMemo(
    () => certificateList?.data?.data.every((item) => item.disable === true),
    //eslint-disable-next-line
    [certificateList],
  );

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentTablePageSize = page_size;
        state.currentTablePage = 1;
      }),
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentTablePage = page;
      }),
    );
  };

  const handleRemarksClick = (data) => {
    dispatch(
      globalUpdateConfig((state) => {
        state.globalRemarkId = data?.id;
        state.globalRemarkModal = true;
      }),
    );
  };

  const handleModalClose = () => {
    dispatch(globalUpdateConfig((state) => (state.globalRemarkModal = false)));
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      status: (_, data) =>
        data?.status === "Rejected" ? (
          <span className={"pro-badge badge-danger-outline pro-d-inline-block"}>
            {"Rejected"}
          </span>
        ) : data?.status === "Marked" ? (
          <span className={"outline-primary pro-badge pro-d-inline-block"}>
            {"Marked"}
          </span>
        ) : data?.status === "Completed" ? (
          <span className={"outline-success pro-badge pro-d-inline-block"}>
            {"Completed"}
          </span>
        ) : data?.status === "Pending" ? (
          <span className={"outline-warning pro-badge pro-d-inline-block"}>
            {"Pending"}
          </span>
        ) : (
          <span className={"outline pro-badge pro-d-inline-block"}>
            {data?.status}
          </span>
        ),
      action: (_, data) => (
        <p className="pro-mb-0">
          {
            <Button
              className={"pro-btn-primary"}
              onClick={() => handleRemarksClick(data)}
            >
              Remarks
            </Button>
          }
        </p>
      ),
    };

    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleConfirmModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showAddDeliverySecModal = !state.showAddDeliverySecModal;
        state.selectedDeliverySection = e;
      }),
    );
  };
  const handleConfirm = (values) => {
    let data = {
      item_details_id: deliveryState.selectedDeliverySection,
      status: values?.status,
      remarks: values?.remarks,
    };
    let newObj = Object.entries(data);
    newObj = newObj
      .filter(
        (item) => item[1] !== undefined && item[1] !== "" && item[1] !== null,
      )
      .reduce((a, v) => ({ ...a, [v[0]]: v[1] }), {});
    approveCertificate(newObj).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Success");
        handleConfirmModal();
        refetch();
        dispatch(updateConfig((state) => (state.clear = true)));
        const timeOut = setTimeout(() => {
          dispatch(updateConfig((state) => (state.clear = false)));
          clearTimeout(timeOut);
        }, 1000);
      } else {
        toast.error("Something went wrong");
        handleConfirmModal();
      }
    });
  };

  const handlePrintSlip = () => {
    setLoading(true);
    const stockId = deliveryState?.selectedCardId;
    getPrintSlip(stockId).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig((state) => (state.printData = response?.data?.data)),
        );
        toast.success("Sucessfully Downloaded ");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
      const printSlip = () => {
        const element = slipRef?.current;
        html2pdf(element, {
          margin: [2, 2, 2, 2],
          filename: `${response?.data?.data?.gli_number || ""}_Delivery Slip_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };

  const handlePrintChellan = () => {
    setLoadingChellan(true);
    const stockId = deliveryState?.selectedCardId;
    getPrintChellan(stockId).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig(
            (state) => (state.printChellanData = response?.data?.data),
          ),
        );
        toast.success("Sucessfully Downloaded ");
        setLoadingChellan(false);
      } else {
        setLoadingChellan(false);
        toast.error("Something went wrong");
      }
      let gliCardData = deliveryState.deliverySectionData.Pending.find(
        (item) => item?._id === response?.data?.data?.stock_receipt_id,
      );
      const printSlip = () => {
        const element = chellanRef?.current;
        html2pdf(element, {
          margin: [10, 2, 2, 2],
          filename: `${gliCardData?.gli_number || ""}_Delivery Challan_${gliCardData?.challan_number || ""}_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: {
            dpi: 100,
            letterRendering: true,
            useCORS: true,
            logging: true,
            scale: 4,
            scrollY: 0,
          },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
          DisablePdfCompression: true,
        });
      };
      setTimeout(() => {
        printSlip();
      }, 500);
    });
  };

  const handlePassAllClick = () => {
    dispatch(
      globalUpdateConfig((state) => (state.passAllModal = !state.passAllModal)),
    );
  };

  const handlePassAll = () => {
    let data = {
      stock_receipt_id: deliveryState?.selectedCardId,
      process_slug: slug,
      remarks: formik?.values?.remark,
    };

    passAll(data).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success(response?.data?.message);
        refetch();
        handlePassAllClick();
        formik?.resetForm();
        dispatch(updateConfig((state) => (state.clear = true)));
        const timeOut = setTimeout(() => {
          dispatch(updateConfig((state) => (state.clear = false)));
          clearTimeout(timeOut);
        }, 1000);
      } else if (response?.status_code === 403) {
        toast.error(response?.message ?? "Error ");
      } else {
        toast.error(response?.data?.message);
      }
    });
  };
  const handleEditPrintModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showPrintEditModal = !state.showPrintEditModal;
        state.isEdit = true;
      }),
    );
    let params = {
      stock_receipt_id: deliveryState.selectedCardId,
    };
    dispatch(getDeliveryChallanEditData(params));
  };
  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showPrintEditModal = false;
        state.isEdit = false;
        state.deliveryChallanEditData = {};
      }),
    );
  };
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentTablePage = 1;
      }),
    );
  };
  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleUploadModalOpen = () => {
    setShowUploadModal(true);
    setUploadFile(null);
  };

  const handleUploadModalClose = () => {
    setShowUploadModal(false);
    setUploadFile(null);
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        ".csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (allowedTypes.includes(file.type)) {
        if (file.size <= 2 * 1024 * 1024) {
          setUploadFile(file);
        } else {
          toast.error("File size should be less than 2MB");
        }
      } else {
        toast.error(
          "Invalid file type. Please upload Excel, PDF, JPG, or PNG files",
        );
      }
    }
  };

  const handleUploadSubmit = () => {
    if (!uploadFile) {
      toast.error("Please select a file");
      return;
    }
    setUploadLoading(true);
    const formData = new FormData();
    formData.append("receipt_id", deliveryState?.selectedCardId);
    formData.append("eway_bill_delivery", uploadFile);
    uploadDeliveryChallan(formData).then((response) => {
      setUploadLoading(false);
      if (response?.data?.status_code === 200) {
        toast.success("File uploaded successfully");
        handleUploadModalClose();
      } else if (response?.status_code === 422 && response?.errors) {
        Object.keys(response.errors).forEach((field) => {
          toast.error(response.errors[field]);
        });
      } else {
        toast.error("Unable to upload file, please try again");
      }
    });
  };

  const handleDeliveryDownload = () => {
    const receiptId = deliveryState?.selectedCardId;
    downloadDeliveryExcel(receiptId, "eway_bill_delivery").then((response) => {
      if (response?.data?.data?.url) {
        const { url, extension } = response.data.data;
        let downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.setAttribute(
          "download",
          `Eway_Bill_Delivery_${moment(Date.now()).format("MM_DD_YYYY_HH_mm_ss")}.${extension}`,
        );
        downloadLink.target = "_blank";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        toast.success("Eway Bill Delivery downloaded successfully.");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    });
  };

  return {
    paginationOptions,
    disableMultiSelect,
    deliveryState,
    certificateList,
    isFetching,
    formik,
    globalRemarkModal,
    passAllModal,
    isLoading,
    handleSearch,
    handleClearClick,
    loading,
    loadingChellan,
    handleModalClose,
    handlePassAllClick,
    handlePrintChellan,
    handlePrintSlip,
    getRow,
    handlePageSize,
    handleConfirm,
    handlePagination,
    handleConfirmModal,
    handlePassAll,
    handleEditPrintModal,
    handleCloseModal,
    showUploadModal,
    uploadLoading,
    uploadFile,
    handleUploadModalOpen,
    handleUploadModalClose,
    handleFileChange,
    handleUploadSubmit,
    handleDeliveryDownload,
  };
};

export default useDeliveryCertificate;
